if (!customElements.get('subscription-selector')) {
  customElements.define(
    'subscription-selector',
    class SubscriptionSelector extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('[data-selling-plan-select]');
        this.section = this.closest('section')

        this.addEventListener('change', event => {
          if(!event.target.closest('[data-purchase-option]')) return;          

          this.select.toggleAttribute('disabled', event.target.dataset.purchaseOption == "one-time")

          this.section.dispatchEvent(new CustomEvent('selling_plan:changed', { bubbles: true }))
        })
      }
    }
  );
}
